import { render, staticRenderFns } from "./projectorder.vue?vue&type=template&id=73f13de2&"
import script from "./projectorder.vue?vue&type=script&lang=js&"
export * from "./projectorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports